var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5947 7.93189C18.1971 7.93189 19.4969 6.63298 19.4969 5.03064C19.4969 3.42831 18.1971 2.12939 16.5947 2.12939",
    stroke: "#5E94AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9292 11.0845C18.4077 11.1175 18.8834 11.1853 19.3519 11.2907C20.0027 11.4181 20.7855 11.6849 21.0642 12.2688C21.242 12.6428 21.242 13.0782 21.0642 13.4531C20.7864 14.0371 20.0027 14.3029 19.3519 14.4367",
    stroke: "#5E94AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28986 7.93189C3.68753 7.93189 2.3877 6.63298 2.3877 5.03064C2.3877 3.42831 3.68753 2.12939 5.28986 2.12939",
    stroke: "#5E94AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95565 11.0845C3.47715 11.1175 3.0014 11.1853 2.53298 11.2907C1.88215 11.4181 1.09931 11.6849 0.821563 12.2688C0.642813 12.6428 0.642813 13.0782 0.821563 13.4531C1.0984 14.0371 1.88215 14.3029 2.53298 14.4367",
    stroke: "#5E94AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9377 11.7095C14.1845 11.7095 16.9583 12.2008 16.9583 14.1671C16.9583 16.1324 14.2028 16.6421 10.9377 16.6421C7.68991 16.6421 4.91699 16.1507 4.91699 14.1845C4.91699 12.2182 7.67249 11.7095 10.9377 11.7095Z",
    stroke: "#5E94AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9374 8.90492C8.79602 8.90492 7.0791 7.188 7.0791 5.04575C7.0791 2.90442 8.79602 1.1875 10.9374 1.1875C13.0787 1.1875 14.7956 2.90442 14.7956 5.04575C14.7956 7.188 13.0787 8.90492 10.9374 8.90492Z",
    stroke: "#5E94AD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.e0d278f29fe0ab3d6a1d94e4b196d6cc.svg";
export { ForwardRef as ReactComponent };